"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sound = void 0;
var utils_1 = require("./utils");
var soundBitrate = 128000;
var soundSampleRate = 48000;
exports.sound = {
    convert: function (soundInput) {
        (0, utils_1.log)('Convert sound');
        return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var ctx, decodedBuffer, encodedChunks, encoder, leftChannelData, rightChannelData, interleavedData, src, dst, audioData, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ctx = new AudioContext();
                        return [4 /*yield*/, ctx.decodeAudioData(soundInput)];
                    case 1:
                        decodedBuffer = _b.sent();
                        encodedChunks = [];
                        encoder = new AudioEncoder({
                            output: function (chunk) {
                                // get chunk bytes and push to array of chunks
                                var chunkBuffer = new ArrayBuffer(chunk.byteLength);
                                chunk.copyTo(chunkBuffer);
                                encodedChunks.push(chunkBuffer);
                            },
                            error: reject,
                        });
                        encoder.configure({
                            codec: 'opus',
                            bitrate: soundBitrate,
                            sampleRate: soundSampleRate,
                            numberOfChannels: 2,
                        });
                        // interleave two channel (stero) audio
                        if (decodedBuffer.numberOfChannels == 0) {
                            reject(new Error('cannot read sound with zero channels'));
                            return [2 /*return*/];
                        }
                        leftChannelData = decodedBuffer.getChannelData(0);
                        rightChannelData = decodedBuffer.numberOfChannels >= 2
                            ? decodedBuffer.getChannelData(1)
                            : leftChannelData;
                        interleavedData = new Float32Array(leftChannelData.length +
                            (rightChannelData ? rightChannelData.length : 0));
                        for (src = 0, dst = 0; src < leftChannelData.length; src++, dst += rightChannelData ? 2 : 1) {
                            interleavedData[dst] = leftChannelData[src];
                            interleavedData[dst + 1] = rightChannelData[src];
                        }
                        audioData = new AudioData({
                            format: 'f32',
                            numberOfChannels: 2,
                            numberOfFrames: decodedBuffer.length,
                            sampleRate: soundSampleRate,
                            timestamp: 0,
                            data: interleavedData,
                        });
                        // start encoder
                        encoder.encode(audioData);
                        return [4 /*yield*/, encoder.flush()];
                    case 2:
                        _b.sent();
                        // add chunks to array
                        _a = resolve;
                        return [4 /*yield*/, new Blob(encodedChunks.flatMap(function (c) { return [
                                Uint16Array.from([c.byteLength]).buffer,
                                c,
                            ]; })).arrayBuffer()];
                    case 3:
                        // add chunks to array
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); });
    },
};
